import React, { Component, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { processFdi } from '../../utils/fdiProcessor';

import routes from '../../routes';
import { proxyApiRequest } from '../../api';
const controllerUrl = process.env.REACT_APP_CTRL_URL;

class DefaultLayout extends Component {
	state = {
		state: null,
		components: null,
	};
	loading = () => <div className="animated fadeIn pt-1 text-center"></div>;

	componentDidUpdate() {
		console.log(`Default did update`, window.location, this.props);
	}
	async componentDidMount() {
		if (localStorage) {
			localStorage.setItem('lastSession', new Date());
		}
		const path = window.location.pathname;
		// history.listen(({ action, location }) => {
		// 	console.log(`DEFAULT: The current URL is ${location.pathname}${location.search}${location.hash}`);
		// 	console.log(`DEFAULT: The last navigation action was ${action}`);

		// 	processBackButton(action, location, history, this.props);
		// });

		let proceed = true;
		// Back button check
		//proceed = proceed && (await processBackButton(path, this.props));

		console.log('componentDidMount - props', this.props);

		// Redirection logic
		proceed = proceed && (await processFdi(this.props));

		if (proceed && window.location.pathname.length > 1) {
			console.log(`path`, path);
			if (path.match(/^\/care\/?$|getCare\/?/)) {
				window.location.assign(
					`/#/desktop/getCare` + (window.location.search ? `${window.location.search}` : ''),
				);
				return;
			}
			if (path.match(/^\/resources\/?/)) {
				window.location.assign(
					`/#/desktop/resources` + (window.location.search ? `${window.location.search}` : ''),
				);
				return;
			}
			if (path.match(/^\/verify\/?/)) {
				window.location.replace(`/#/signup` + (window.location.search ? `${window.location.search}` : ''));
				return;
			}
			if (path.match(/^\/oic\/?/)) {
				window.location.assign(
					`/#/openScheduling` + (window.location.search ? `${window.location.search}&flow=oic` : '?flow=oic'),
				);
				return;
			}
			if (path.match(/^\/finddoc\/?/)) {
				window.location.assign(
					`/#/openScheduling` +
						(window.location.search ? `${window.location.search}&flow=finddoc` : '?flow=finddoc'),
				);
				return;
			}
			if (path.match(/^\/conditions\/?/)) {
				window.location.assign(
					`/#/openScheduling` +
						(window.location.search ? `${window.location.search}&flow=conditions` : '?flow=conditions'),
				);
				return;
			}
			if (path.match(/^\/openScheduling\/?/)) {
				window.location.assign(
					`/#/openScheduling` + (window.location.search ? `${window.location.search}` : ''),
				);
				return;
			}
		}

		window.addEventListener('setStateData', (ev) => {
			console.log('Setting State data:', ev.detail);
			this.setPassedState(ev.detail, this.props.history);
			this.setState({ state: ev.detail.state, components: ev.detail.components });
		});

		if (window.stateData != null) {
			const event = new CustomEvent('setStateData', { detail: window.stateData });
			console.log('Dispatching setStateData event:', event);
			window.dispatchEvent(event);
		} else {
			// const pathname = this.props.location.pathname.replace('/', '');
			// const nextState = await axios
			// 	.post(controllerUrl, { state: pathname ? pathname : '', event: '', accountID: 603 })
			// 	.then((response) => {
			// 		console.log('RESPONSE:', response.data);
			// 		const { state } = response.data;
			// 		let route;
			// 		switch (state) {
			// 			case 'home':
			// 				route = '/';
			// 				break;
			// 			default:
			// 				route = `/${state}`;
			// 				break;
			// 		}
			// 		return { ...response.data, route };
			// 	});
			// if (nextState) {
			// 	// console.log(nextState.viewModel);
			// 	this.setState({
			// 		state: nextState.state,
			// 		components: nextState.viewModel.components.webview
			// 			? JSON.parse(nextState.viewModel.components.webview.model).components
			// 			: null,
			// 	});
			// }
		}
	}

	async getNextState(data) {
		const { action, state, event } = data;

		// if (action === 'link' && event && matchYoutubeUrl(event)) {
		// 	const youtube = matchYoutubeUrl(event);
		// 	console.log(youtube);
		// 	return;
		// }
		let bridge = null;
		if (window.androidBridge) {
			bridge = window.androidBridge;
		} else if (window.webkit && window.webkit.messageHandlers) {
			bridge = window.webkit.messageHandlers.postEvent;
		}
		console.log('bridge', data);
		if (bridge) {
			bridge.postMessage(JSON.stringify(data));
		} else {
			// const { action, state, event } = data;
			console.log('POST to controller:', { action, state, event });

			const response = await proxyApiRequest(controllerUrl, { state, event });

			console.log('RESPONSE:', response.data);
			const { state: retState } = response.data;
			let route;
			switch (retState) {
				case 'home':
					route = '/';
					break;
				default:
					route = `/${retState}`;
					break;
			}
			return { ...response.data, route };
		}
	}

	// state, event, history,
	async setNextState({
		event,
		action,
		history,
		url = null,
		fdiId = null,
		employer = null,
		params = null,
		closeConfirmationModal,
	}) {
		const regURL = /^((http|https):\/\/)/;
		const phoneAction = /^tel:/;
		// const myChartAction = /^myChart:/;

		let stateData = {
			state: this.state.state,
			action: regURL.test(event) ? 'link' : action,
			event,
			url: action,
			closeConfirmationModal,
		};

		if (action === 'link') {
			stateData.action = 'link';
			stateData.url = url;
		}

		if (action === 'fs-link') {
			stateData.action = 'fs-link';
			stateData.url = url;
		}

		if (action === 'fs-fdi-link') {
			stateData.action = 'fs-fdi-link';
			stateData.fdiId = fdiId ? fdiId : '100021';
			stateData.params = params;
		}

		if (action === 'selectBookOnline' || action === 'selectOnSiteClinic' || action === 'selectSameDayCare') {
			stateData.action = 'dfd';
		}

		if (action === 'selectEmployerContent') {
			stateData.action = 'dfd';
			stateData.employer = employer;
		}

		// set up the phone links (keep this after the link test)
		if (phoneAction.test(url)) {
			stateData.action = 'phone';
			stateData.url = url;
		}
		const nextState = await this.getNextState(stateData);
		console.log('Next state', nextState);
		this.setState(nextState);
		if (nextState && nextState.route) {
			history.push(nextState.route);
		}
	}

	async setPassedState(passedState, history) {
		console.log('Setting State data:', passedState);
		this.setState(passedState, () => history.push(passedState.state === 'home' ? '/' : `/${passedState.state}`));
	}

	async handleClick(history) {
		const passedState = JSON.parse(document.getElementById('passedData').value);
		console.log('Passed Data:', passedState);
		this.setState(passedState);
		history.push(passedState.state === 'home' ? '/' : `/${passedState.state}`);
	}

	render() {
		return (
			this.state.state && (
				<div className="app">
					<div className={this.state.state === 'home' ? 'app-body home' : 'app-body'}>
						<main className="main">
							<Suspense fallback={this.loading()}>
								<Switch>
									{routes.map((route, idx) => {
										return route.component ? (
											<Route
												key={idx}
												path={route.path}
												exact={route.exact}
												name={route.name}
												render={(props) => (
													<route.component
														{...props}
														{...this.state}
														setNextState={this.setNextState.bind(this)}
														setPassedState={this.setPassedState.bind(this)}
														handleClick={this.handleClick.bind(this)}
													/>
												)}
											/>
										) : null;
									})}
								</Switch>
							</Suspense>
						</main>
					</div>
				</div>
			)
		);
	}
}
export default DefaultLayout;
